import { createClient } from "@connectrpc/connect";

import { transport } from "./transport";

import {
  AdminService,
  AnalyticsService,
  AuditLogsService,
  AuthService,
  BlacklistService,
  ConsignmentNoteService,
  ContractService,
  ContainerService,
  CustomGroupService,
  DriverIncidentService,
  DriverOnShiftService,
  DriverService,
  OrganizationService,
  ScaleService,
  TruckService,
  UserService,
  GovDashService,
  GroupMembershipService,
  WhatsappService,
  ResourceAccessGrantService,
  RouteService,
  JobService,
  LocationService,
  NotificationService,
  PickupLocationService,
  ContactService,
  EcoInspectService,
  VrpRoutingService,
  ShiftPlanService,
  TeamService,
} from "../gen";

export const auditLogsClient = createClient(AuditLogsService, transport);
export const authClient = createClient(AuthService, transport);
export const contractClient = createClient(ContractService, transport);
export const containerClient = createClient(ContainerService, transport);
export const customGroupClient = createClient(CustomGroupService, transport);
export const driverClient = createClient(DriverService, transport);
export const truckClient = createClient(TruckService, transport);
export const organizationClient = createClient(OrganizationService, transport);
export const scaleClient = createClient(ScaleService, transport);
export const userClient = createClient(UserService, transport);
export const govDashClient = createClient(GovDashService, transport);
export const adminClient = createClient(AdminService, transport);
export const groupMembershipClient = createClient(GroupMembershipService, transport);
export const resourceAccessGrantClient = createClient(ResourceAccessGrantService, transport);
export const routeClient = createClient(RouteService, transport);
export const driverOnShiftClient = createClient(DriverOnShiftService, transport);
export const driverIncidentClient = createClient(DriverIncidentService, transport);
export const jobClient = createClient(JobService, transport);
export const whatsappClient = createClient(WhatsappService, transport);
export const locationClient = createClient(LocationService, transport);
export const pickupLocationClient = createClient(PickupLocationService, transport);
export const notificationClient = createClient(NotificationService, transport);
export const contactClient = createClient(ContactService, transport);
export const ecoInspectClient = createClient(EcoInspectService, transport);
export const blacklistClient = createClient(BlacklistService, transport);
export const vrpRoutingClient = createClient(VrpRoutingService, transport);
export const analyticsClient = createClient(AnalyticsService, transport);
export const shiftPlanClient = createClient(ShiftPlanService, transport);
export const consignmentNoteClient = createClient(ConsignmentNoteService, transport);
export const teamClient = createClient(TeamService, transport);
